$(document).ready(function () {

    let alertOpen = false;

    $(document)
        .on('change', '.js_table-search :input', searchTable)
        .on('submit', '.js_table-search', searchTable)
        .on('change', '#hide_filter', changeFilterMode)
        .on('click', '.js_table-pagination a', paginateTable)
        .on('click', '.btn-filter-submit', searchTableSubmit)
        .on('click', '.js_table-reset', resetSearchTable)
        .on('panel-form-ajax-success', '.js_form-ajax', resetAjaxForm)
        .on('click', '#side-menu .pjax-link', activeMenu)
        .on('click', '#side-menu .pjax-link', activeMenu)
        .on('change', '.js_order-type-ticket', changeTicketType)
        .on('change', '.js_custom-select-preselect', changeDependentSelect);

    $(document).pjax('.pjax-link', '#pjax-container', { fragment: '#pjax-container', timeout: 20000 });

    function activeMenu() {
        $('#side-menu li').not('.sub-menu').removeClass('active');
        $(this).closest('li').addClass('active');
    }

    $('#pjax-container').on('pjax:beforeSend', () => {
        $('.wrapper-spinner').show();
    })

    $('#pjax-container').on('pjax:complete', () => {
        $('.wrapper-spinner').hide();
        window.initSortable();
        window.map();
        window.initSortableStation();
        window.initOrderClientPhone();
        window.initTemplateBus();
        $('[data-toggle="tooltip"]').tooltip();
        init();
    })

    function resetAjaxForm(e, response) {
        let $back = $('.js_form-ajax-back');
        if (response.redirect_url) $back.attr('href', response.redirect_url)
        if ($(this).hasClass('js_form-ajax-reset') || response.redirect_url) {
            setTimeout(() => $back.click(), 500);
        }
    }

    function searchTable(e) {
        e.preventDefault();
        if ($('input[name="is_filter"]').length) {
            $('input[name="is_filter"]').val(1);
        }
        if ($(this).is('input') && $(this).hasClass('select2-search__field')) {
            return false;
        }
        $('.wrapper-spinner').show();
        let $form = $('.js_table-search');
        history.pushState({}, '', '?' + $form.serialize());
        $form.ajaxSubmit({
            success: function (data) {
                $('.wrapper-spinner').hide();
                renderData(data);
            }
        });
        return false;
    }

    function searchTableSubmit(e, hide_filter = false) {
        e.preventDefault();
        $('.wrapper-spinner').show();
        let $form = $('.js_table-submit');

        // let condition_str = e.target.checked ? $form.serialize() + "&" + e.target.name + "=1" : $form.serialize();
        // history.pushState({}, '', '?' + condition_str);
        let data = serializeObject($form.serializeArray());
        if (hide_filter) {
            data['hide_filter'] = 1;
        }
        console.log(data);
        let link = $form.data("link");
        $(".close").trigger("click");
        $.ajax({
            type: "POST",
            url: link,
            data: data, // serializes the form's elements.
            success: function (data) {
                $('.wrapper-spinner').hide();
                renderData(data);
            }
        });
        return false;
    }

    function serializeObject(serializeArray) {
        console.log(serializeArray);
        var result = {};
        result['fields'] = [];

        serializeArray.map(function (item) {
            console.log(item['name']);
            if (item['name'] == "fields[]") {
                result['fields'].push(item['value']);
            } else {
                result[item['name']] = item['value'];
            }
        })
        return result;
    }

    function paginateTable(e) {
        e.preventDefault();
        let link = $(this).attr('href');
        $('#js-current-page').val($(this).text());
        $('.wrapper-spinner').show();
        $.get(link, function (data) {
            $('.wrapper-spinner').hide();
            renderData(data);
            $.scrollTo($('.ibox-content'), 400);
        });
        return false;
    }

    function renderData(data) {
        let $table = $('.js_table-wrapper');
        let $pagination = $('.js_table-pagination');
        let $filter = $('.filter-data');
        $table.html(data.view);
        $pagination.html(data.pagination);
        data.filter ? $filter.html(data.filter) : '';
        $('[data-toggle="tooltip"]').tooltip();
        initCollapseColumn();
        initPopper();
        $('.packages-button').addClass('packages-button-active').css('display', 'inline')
        $('.tours-button').removeClass('tours-button-active').css('display', 'none')
    }

    function resetSearchTable(e) {
        $(document).off('change', '.js_table-search :input', searchTable)

        e.preventDefault();
        let $form = $('.js_table-search');
        $form.find('input').not('.js_table-reset-no').val('');
        $form.find('textarea').val('');
        $form.find('select').val('').trigger('change');

        $(document).on('change', '.js_table-search :input', searchTable)
        searchTable(e);
        return false;
    }


    function init() {

        $(".js_input-select2").select2({
            allowClear: true
        });

        $(".js_select2-sortable").parent().find("ul.select2-selection__rendered").sortable({
            containment: 'parent',
            update: function () {
                $(this).parent().find("ul.select2-selection__rendered").children("li[title]").each(function (i, obj) {
                    let element = $(this).closest('.select2-container').prev(".js_select2-sortable").find('option').filter(
                        function () { return $(this).html() == obj.title; }
                    );
                    moveElementToEndOfParent(element);
                });
            }
        });

        moveElementToEndOfParent = function (element) {
            var parent = element.parent();
            element.detach();
            parent.append(element);
        };

        $('.time-mask').inputmask({
            alias: "h:s"
        })

        $('.js_datepicker').datepicker({
            changeMonth: true,
            changeYear: true,
            startDate: '-1200m'
        }).on('changeDate', function (ev) {
            if ($(this).hasClass('js_table-reset-no')) $(this).trigger('change');
            if ($(this).data('date')) {
                let $date = $('[name=date]');
                $date.val($('.js_datepicker').datepicker('getFormattedDate'));
                $date.trigger('change');
            }
        });

        $('.js_datepicker2').datepicker({
            changeMonth: true,
            changeYear: true,
            startDate: '-1200m'
        }).on('changeDate', function (ev) {
            if ($(this).hasClass('js_table-reset-no')) $(this).trigger('change');
            if ($(this).data('date')) {
                let $date = $('[name=date]');
                $date.val($('.js_datepicker').datepicker('getFormattedDate'));
                $date.trigger('change');
            }
        });

        $('.js_datepicker_without_previous').datepicker({
            // format: defaultDateFormat,
            // autoclose: true,
            // todayHighlight: true,
            // language: 'ru',
            // dateFormat: 'dd.mm.yyyy',
            changeMonth: true,
            changeYear: true,
            // startDate: '-1200m',
            minDate: 0,
            startDate: new Date(),
        }).on('changeDate', function (ev) {
            if ($(this).hasClass('js_table-reset-no')) $(this).trigger('change');
            if ($(this).data('date')) {
                let $date = $('[name=date]');
                $date.val($('.js_datepicker_without_previous').datepicker('getFormattedDate'));
                $date.trigger('change');
            }
        });

        $('.input-daterange').datepicker({
            // format: defaultDateFormat,
            keyboardNavigation: false,
            forceParse: true,
            toggleActive: false,
            // language: 'ru',
            // autoclose: true,
        }).on('changeDate', function (ev) {
            $(this).trigger('input');
        });

        $('#is_egis-yes').on('click', function () {
            if (confirm('Установить обязательные поля для заполнения в соответствии с требованиями ЕГИС?')) {
                $(".js_input-select2").val(['first_name', 'last_name', 'middle_name', 'doc_type', 'doc_number', 'phone', 'birth_day', 'gender', 'country_id']).trigger("change");
            }
        });

        $(".js-select-search-tours, .js_city_from_id, .js_city_to_id, .js-select-company, .js-select2-custom").each(function () {
            var $this = $(this);
            $this.select2({
                width: "100%",
                sorter: data => data.sort((a, b) => a.text.localeCompare(b.text))
            }).on('select2:unselecting', function () {
                $(this).data('unselecting', true);
            }).on('select2:opening', function (e) {
                if ($(this).data('unselecting')) {
                    $(this).removeData('unselecting');
                    e.preventDefault();
                }
            });
        });

        $('.js_select-trigger').on('change', function () {
            let self = $(this),
                name = self.attr('name'),
                val = self.val();

            $('div[id^="trigger-' + name + '"]').hide();
            $('#trigger-' + name + '-' + val).show();
        })

        $(".js-select-company").on('change', function () {
            if ('URLSearchParams' in window) {
                var searchParams = new URLSearchParams(window.location.search);
                searchParams.set($(this).attr("name"), $(this).find(":selected").val());
                searchParams.set("driver_id", '');
                window.location.search = searchParams.toString();
            }
        });

        initPopper();
        initCollapseColumn();

        if ($('input[name="has_filters"]').length) {
            if ($('input[name="has_filters"]').val() != '0') {
                $('.js_table-search').trigger('submit');
            }
        }
    }

    init();

    window.init = init;

    $(document).on('click', '.onoffswitch-checkbox-panel', function () {
        var placeId = $(this).data('place_id');
        console.log(placeId);
        var elPrice = "#order_place_price_" + placeId;
        var elSpan = "#order_place_span_" + placeId;
        if ($(elPrice).is(":visible")) {
            $(elPrice).hide();
            $(elSpan).show();
        } else {
            $(elPrice).show();
            $(elSpan).hide();
        }
        return true;
    });

    $(document).on('click', '.onoffswitch-checkbox', function () {
        let placeId = $(this).data('place_id'),
            url = $('.js_div_order_places').data('url')
        data = [];

        if (placeId) {
            let elPrice = "#order_place_price_" + placeId,
                elSpan = "#order_place_span_" + placeId;

            if ($(elPrice).is(":visible")) {
                $(elPrice).hide();
                $(elSpan).show();
            } else {
                $(elPrice).show();
                $(elSpan).hide();
            }

            data = $('.js_div_order_places :input').serializeArray();
        } else if ($(this).attr('name') === 'pass_not_client') {
            let block = $('.js_block_pass_not_clients'),
                checkbox = $('.js_checkbox_pass_not_clients');
            if ($(this).is(':checked')) {
                block.show();
                checkbox.val(1);
            } else {
                block.hide();
                checkbox.val(0);
            }

            let data = $('.js_div_order_places :input').serializeArray();
            let passNoClientEnable = false;

            $.each(data, function (i, field) {
                if (field.name == 'pass_not_client') {
                    passNoClientEnable = true;
                }
            });

            if (!passNoClientEnable) {
                $.each(data, function (i, field) {
                    if (field.name.indexOf('price') == -1) {
                        field.value = '';
                    }
                });
            }
        }

        if (data.length !== 0) {
            $.post(url, data);
        }

        return true;
    });

    function changeTicketType() {
        let self = $(this),
            placeId = self.data('placeid'),
            priceElement = $("#js_order_place_price_span_" + placeId),
            discountElement = $("#js_place-discount-span-" + placeId),
            priceDefault = parseFloat(priceElement.data('default-price').toString().replace(/\s+/g, ''));

        if (self.val() == 'default') {
            discountElement.hide();
            setPriceTicketType(priceElement, priceDefault);
        } else {
            let discountType = self.data('discount_type'),
                discountValue = self.data('discount_value'),
                discountMessage = self.data('discount_message'),
                priceCustom = discountType ? (priceDefault * (100 - discountValue) / 100) : (priceDefault - discountValue);

            discountElement.text(discountMessage).show();
            setPriceTicketType(priceElement, priceCustom);
        }
    }
    function setPriceTicketType(elem, value) {
        elem.text(value.toLocaleString('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 }));

        updateTotalTicketType();
    }
    function updateTotalTicketType() {
        let totalPrice = 0,
            prices = $('.js_order_place_price_span');

        prices.each(function () {
            let self = $(this);

            totalPrice += parseFloat(self.text().replace(/\s+/g, ''));
        });

        $("#js_span_amount_price").html(totalPrice.toLocaleString('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 }));

        setTicketType('child');
        setTicketType('pensioner');
    }
    function setTicketType(keyword) {
        let Ids = [];

        $('input[name="count_' + keyword + '"]').val($('.js_order-type-ticket[value="' + keyword + '"]:checked').length);
        $('.js_order-type-ticket[value="' + keyword + '"]').each((index, element) => {
            if (element.checked) {
                Ids.push(index);
            }
        });
        $('input[name="' + keyword + 'Ids"]').val(Ids.toString());
    }


    function changeFilterMode(e) {
        searchTableSubmit(event, true);
    }

    function initPopper() {
        $('.popper-dropdown').remove();

        if ($('.popper').length > 0) {
            $('.popper').each(function () {
                let self = $(this);

                popper({
                    trigger: self.children('button'),
                    contentEl: self.children('.popper-menu'),
                    tooltipDesktopPosition: 'top',
                });
            })
        }
    }

    // Column Colapse
    let collapseColumnsClass = '.column-collapse',
        collapseNameClass = collapseColumnsClass + '__name',
        collapseActionClass = collapseColumnsClass + '__action',
        collapseMinifyClass = 'minifyColumn';

    initCollapseColumn();

    $(document)
        .on('click', collapseColumnsClass + ':not(.' + collapseMinifyClass + ') ' + collapseActionClass, function () {
            collapseColumn($(this).parent(collapseColumnsClass));
        })
        .on('click', collapseColumnsClass + '.' + collapseMinifyClass + ' ' + collapseActionClass, function () {
            expandColumn($(this).parent(collapseColumnsClass));
        })

    function initCollapseColumn() {
        if ($(collapseColumnsClass + '.' + collapseMinifyClass).length) {
            collapseColumns();
        }
    }

    function collapseColumns() {
        $(collapseColumnsClass + '.' + collapseMinifyClass).each(function () {
            collapseColumn($(this));
        })
    }

    function collapseColumn(col) {
        let widthCol = (col.children(collapseNameClass).length) ? col.children(collapseNameClass).outerWidth(true) + col.children(collapseActionClass).outerWidth(true) : false,
            indexCol = col.index();

        col
            .addClass(collapseMinifyClass)
            .closest('thead').siblings('tbody').children('tr').each(function () {
                let td = $(this).find('td').eq(indexCol);
                td.addClass(collapseMinifyClass)
                if (widthCol) {
                    td.css('max-width', widthCol);
                }
            })
    }

    function expandColumn(col) {
        let indexCol = col.index();

        col
            .removeClass(collapseMinifyClass)
            .closest('thead').siblings('tbody').children('tr').each(function () {
                $(this).find('td').eq(indexCol).css('max-width', 'none').removeClass(collapseMinifyClass);
            })
    }
    // Column Colapse

    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = name + "=" + value + ";path=/;expires=" + date.toUTCString();
    }

    $(".navbar-minimalize").on("click", function () {
        if ($("body").hasClass("mini-navbar")) {
            setCookie("menu_state", "hidden", 7);
        } else {
            setCookie("menu_state", "", -1);
        }
    });

    function changeDependentSelect() {
        let self = $(this),
            id = self.find('option:selected').data(self.data('dependent-field')),
            select = self.data('dependent-select');

        if ( $(select).length && id ) {
            $(select).val(id).trigger('change');
        }
    }
});
